export default "__VITE_ASSET__C9snTj90__"